// src/features/tournament/useControllerSettings.js
import { useState, useEffect, useCallback } from 'react';

const LOCAL_STORAGE_KEY = 'pokerTimerControllerSettings';

const initialSettings = {
  isIntegratedViewEnabled: false,
};

export const useControllerSettings = () => {
  const [settings, setSettings] = useState(() => {
    try {
      const savedSettings = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (savedSettings) {
        return JSON.parse(savedSettings);
      }
    } catch (error) {
    }
    return initialSettings;
  });

  useEffect(() => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
    }
  }, [settings]);

  const updateSetting = useCallback((key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  return {
    settings,
    updateSetting,
  };
};
